// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconSafetySanitizing = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M10.64 18v-2h-2v-2h2v-2h2v2h2v2h-2v2z" />,
    <path
      fillRule="evenodd"
      d="M16.054 1H8.64v2h2v3.083a6.03 6.03 0 00-4.873 4.595l-.127.553V23h12V11.23l-.127-.552a6.03 6.03 0 00-4.873-4.595V3h2.586l1.707 1.707 1.414-1.414zM11.64 8a4.026 4.026 0 013.924 3.126l.076.331V21h-8v-9.543l.076-.331A4.026 4.026 0 0111.64 8"
    />
  );
export default SvgIconSafetySanitizing;
